import type { ResolvedFeatureFlag } from './resolve-feature-flags';

/**
 * TTB-322 `ghostPrimaryScheduleButton` treatment gate.
 *
 * Same non-control variation semantics as `isPhoneSwapTreatment`: the
 * experiment enrolls its whole audience with `isEnabled === true`, and
 * variation 1 is always the control/default, so only `variationId > 1`
 * isolates the treatment arm that should render the ghost CTA.
 *
 * Defaults to `false` (control) for a missing flag, a null/non-numeric
 * `variationId`, or the control variation.
 */
export function isGhostScheduleTreatment(flag: ResolvedFeatureFlag | null | undefined): boolean {
	if (!flag?.isEnabled) return false;
	if (flag.variationId == null) return false;
	return Number(flag.variationId) > 1;
}
